import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

export default function useObjectsTypes() {
  const query = useQuery({
    queryKey: [QueryKeyEnum.OBJECTS_TYPES],
    queryFn: async () => (await api.object.getAllObjectTypes()).data.data,
  })

  return query
}
